import { Autocomplete } from "stimulus-autocomplete"

// GeoRef selectors must also reveal their available choices before the user types.
export default class extends Autocomplete {
  connect() {
    super.connect()
    this.inputTarget.addEventListener("focus", this.onInputFocus)
    this.inputTarget.addEventListener("click", this.onInputFocus)
    this.element.addEventListener("georef-autocomplete:invalidate", this.invalidate)
    this.requestSequence = 0
  }

  disconnect() {
    this.inputTarget.removeEventListener("focus", this.onInputFocus)
    this.inputTarget.removeEventListener("click", this.onInputFocus)
    this.element.removeEventListener("georef-autocomplete:invalidate", this.invalidate)
    super.disconnect()
  }

  onInputFocus = () => this.fetchResults()

  invalidate = () => {
    this.requestSequence += 1
    this.hideAndRemoveOptions()
  }

  buildQueryURL() {
    if (!this.hasUrlValue) return null

    const url = new URL(this.urlValue, window.location.href)
    url.searchParams.set("q", this.inputTarget.value.trim())
    return url.toString()
  }

  fetchResults = async () => {
    const url = this.buildQueryURL()
    if (!url) return

    const requestSequence = ++this.requestSequence
    try {
      this.element.dispatchEvent(new CustomEvent("loadstart"))
      const html = await this.doFetch(url)
      if (requestSequence === this.requestSequence) this.replaceResults(html)
      this.element.dispatchEvent(new CustomEvent("load"))
    } catch (error) {
      this.element.dispatchEvent(new CustomEvent("error"))
    } finally {
      this.element.dispatchEvent(new CustomEvent("loadend"))
    }
  }
}
